import { render, staticRenderFns } from "./RSV.vue?vue&type=template&id=915a859a&"
import script from "./RSV.vue?vue&type=script&lang=js&"
export * from "./RSV.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports